// SharedComponents/breadcrumbStore.js
import { create } from 'zustand';

const useBreadcrumbStore = create((set) => ({
  placeName: null,
  categoryName: null,
  planName: null,  // اضافه کردن planName
  isPageLoading: false,

  // تابعی برای ست کردن داده‌ها (نام مکان، نام دسته، نام برنامه، وضعیت لودینگ)
  setBreadcrumbData: (place, category, plan, isLoading = false) => set({ 
    placeName: place, 
    categoryName: category,
    planName: plan,
    isPageLoading: isLoading 
  }),

  // پاک کردن داده‌ها هنگام ترک صفحه
  clearBreadcrumbData: () => set({ 
    placeName: null, 
    categoryName: null,
    planName: null,
    isPageLoading: false 
  }),
}));

export default useBreadcrumbStore;